import Location1 from "../assets/images/location1.png";
import Location2 from "../assets/images/location2.png";
import Location3 from "../assets/images/location3.png";
import Location4 from "../assets/images/location4.png";
import Location5 from "../assets/images/location5.png";
import Location6 from "../assets/images/location6.png";
import Location7 from "../assets/images/location7.png";
import Location8 from "../assets/images/location8.png";

import LocationCard from "./LocationCard";
import { Link } from "react-router-dom";
const Location = ({ props }) => {
  return (
    <>
      <div className="location-space">
        <div className="location-t-btn">
          <div className="loc-text">
            <h1 className="location-title">Projekt och renoveringar</h1>
            <p className="invest-text">
              De som överger sina plikter är uppmjukade i anden
            </p>
          </div>
          <div className="loc-btn">
            <Link to={"/services"} className="reg-btn border-0">
              Gratis offert
            </Link>
          </div>
        </div>
        <div className="location-card-main">
          <LocationCard
            title={"Rådhus renovering"}
            text={"Järfälla Stockholm"}
            image={Location1}
          />
          <LocationCard
            title={"Lägenheter Renovering"}
            text={"Södertälje Stockholm"}
            image={Location2}
          />
          <LocationCard
            title={"Lägenheter Renovering"}
            text={"Barkarby Stockholm"}
            image={Location3}
          />
          <LocationCard
            title={"Lägenheter Renovering"}
            text={"Bromma Stockholm"}
            image={Location4}
          />
          <LocationCard
            title={"Villa Renovering"}
            text={"Järfälla Stockholm"}
            image={Location5}
          />
          <LocationCard
            title={"Badrumsrenovering"}
            text={"Hägersten Stockholm"}
            image={Location6}
          />
          <LocationCard
            title={"Badrumsrenovering"}
            text={"Barkarby Stockholm"}
            image={Location7}
          />
          <LocationCard
            title={"köksrenovering"}
            text={"Södertälje Stockholm"}
            image={Location8}
          />
        </div>
      </div>
    </>
  );
};

export default Location;
